
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle, runWithConsole, runAndExtract} = await import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("runWithConsole" in module)) throw new SyntaxError(`export 'runWithConsole' not found`);
  if (!("runAndExtract" in module)) throw new SyntaxError(`export 'runAndExtract' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, ok, err, hint, consoleOutput } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,runWithConsole,runAndExtract,codeEditor,ok,err,hint,consoleOutput};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","runWithConsole","runAndExtract","codeEditor","ok","err","hint","consoleOutput"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (view,codeEditor) => {
const demo_arith1 = view(codeEditor("operands:demo_arith1", {
  value: 'const answer = 30 + 12\nconsole.log(answer)'
}));
return {demo_arith1};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_arith1"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-6`),
    expanded: [],
    variables: []
  },
  {
    id: 6,
    body: async (display,consoleOutput,runWithConsole,demo_arith1) => {
display(consoleOutput(await runWithConsole(demo_arith1)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_arith1"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-8`),
    expanded: [],
    variables: []
  },
  {
    id: 8,
    body: (view,codeEditor) => {
const demo_arith2 = view(codeEditor("operands:demo_arith2", {
  value: 'const cappucinoPrice = 4.5\nconst croissantPrice = 2\nconst totalPrice = cappucinoPrice + croissantPrice\n\nconsole.log(totalPrice)'
}));
return {demo_arith2};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_arith2"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-9`),
    expanded: [],
    variables: []
  },
  {
    id: 9,
    body: async (display,consoleOutput,runWithConsole,demo_arith2) => {
display(consoleOutput(await runWithConsole(demo_arith2)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_arith2"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-11`),
    expanded: [],
    variables: []
  },
  {
    id: 11,
    body: (view,codeEditor) => {
const demo_arith3 = view(codeEditor("operands:demo_arith3", {
  value: 'console.log(4 + 2)\nconsole.log(10 - 12)\nconsole.log(5 * 7)\nconsole.log(28 / 4)\nconsole.log(43 % 10)\nconsole.log(2 ** 3)'
}));
return {demo_arith3};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_arith3"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-12`),
    expanded: [],
    variables: []
  },
  {
    id: 12,
    body: async (display,consoleOutput,runWithConsole,demo_arith3) => {
display(consoleOutput(await runWithConsole(demo_arith3)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_arith3"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-14`),
    expanded: [],
    variables: []
  },
  {
    id: 14,
    body: (view,codeEditor) => {
const demo_arith4 = view(codeEditor("operands:demo_arith4", {
  value: 'const secondsPerMinute = 60\nconst minutesPerHour = 60\nconst hoursPerDay = 24\nconst daysPerYear = 365\n\nconst secondsPerHour = secondsPerMinute * minutesPerHour\nconst secondsPerYear = secondsPerHour * hoursPerDay * daysPerYear\n\nconsole.log(secondsPerHour)\nconsole.log(secondsPerYear)'
}));
return {demo_arith4};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_arith4"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-15`),
    expanded: [],
    variables: []
  },
  {
    id: 15,
    body: async (display,consoleOutput,runWithConsole,demo_arith4) => {
display(consoleOutput(await runWithConsole(demo_arith4)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_arith4"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-17`),
    expanded: [],
    variables: []
  },
  {
    id: 17,
    body: (view,codeEditor) => {
const demo_vergleich = view(codeEditor("operands:demo_vergleich", {
  value: 'console.log(5 > 2)\nconsole.log(2 > 10)\nconsole.log(5 >= 5)\nconsole.log(3 < 7)\nconsole.log(8 <= 4)\nconsole.log(4 == 4)\nconsole.log(4 != 5)'
}));
return {demo_vergleich};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_vergleich"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-18`),
    expanded: [],
    variables: []
  },
  {
    id: 18,
    body: async (display,consoleOutput,runWithConsole,demo_vergleich) => {
display(consoleOutput(await runWithConsole(demo_vergleich)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_vergleich"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-21`),
    expanded: [],
    variables: []
  },
  {
    id: 21,
    body: (view,codeEditor) => {
const schalt_code = view(codeEditor("operands:schalt", {
  value: 'const year = 2026\n// dein Code hier — speichere das Ergebnis in `isSchaltjahr` und logge es'
}));
return {schalt_code};
},
    inputs: ["view","codeEditor"],
    outputs: ["schalt_code"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-22`),
    expanded: [],
    variables: []
  },
  {
    id: 22,
    body: async (runWithConsole,schalt_code,display,consoleOutput) => {
const schaltRun = await runWithConsole(schalt_code);
display(consoleOutput(schaltRun));
return {schaltRun};
},
    inputs: ["runWithConsole","schalt_code","display","consoleOutput"],
    outputs: ["schaltRun"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-23`),
    expanded: [],
    variables: []
  },
  {
    id: 23,
    body: (schalt_code,display,hint,html,schaltRun,err,ok) => {
{
  const src = schalt_code;
  const declares = /\b(let|const)\s+isSchaltjahr\s*=/.test(src);
  const usesMod = /%/.test(src);
  const usesEq = /==/.test(src);
  const logs = /console\s*\.\s*log/.test(src);

  if (!declares && !usesMod)
    display(hint(html`Probier <code>const isSchaltjahr = year % 4 == 0</code>.`));
  else if (schaltRun.error)
    display(err(html`Fehler: ${schaltRun.error}`));
  else if (!declares)
    display(err(html`Speichere das Ergebnis in einer Variable namens <code>isSchaltjahr</code>.`));
  else if (!usesMod)
    display(err(html`Du brauchst den <code>%</code>-Operator (Modulo).`));
  else if (!usesEq)
    display(err(html`Du brauchst den <code>==</code>-Operator (Vergleich).`));
  else if (!logs)
    display(err(html`Vergiss nicht, das Ergebnis mit <code>console.log</code> auszugeben.`));
  else if (!schaltRun.logs.includes("false"))
    display(err(html`Hmm, da kommt nicht <code>false</code> raus — 2026 ist nämlich kein Schaltjahr.`));
  else
    display(ok(html`Richtig, 2026 ist <strong>kein</strong> Schaltjahr — der Rest von 2026 / 4 ist nicht 0. 🎉`));
}
},
    inputs: ["schalt_code","display","hint","html","schaltRun","err","ok"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-25`),
    expanded: [],
    variables: []
  },
  {
    id: 25,
    body: (view,codeEditor) => {
const uebung_code = view(codeEditor("operands:final", {
  value: ""
}));
return {uebung_code};
},
    inputs: ["view","codeEditor"],
    outputs: ["uebung_code"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-26`),
    expanded: [],
    variables: []
  },
  {
    id: 26,
    body: async (runWithConsole,uebung_code) => {
const uebungRun = await runWithConsole(uebung_code);
return {uebungRun};
},
    inputs: ["runWithConsole","uebung_code"],
    outputs: ["uebungRun"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-27`),
    expanded: [],
    variables: []
  },
  {
    id: 27,
    body: (display,consoleOutput,uebungRun) => {
display(consoleOutput(uebungRun));
},
    inputs: ["display","consoleOutput","uebungRun"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-28`),
    expanded: [],
    variables: []
  },
  {
    id: 28,
    body: (uebung_code,display,hint,html,uebungRun,err,ok) => {
{
  const src = uebung_code;
  const declaresAge = /\b(let|const)\s+age\s*=\s*\d+/.test(src);
  const declaresAdult = /\b(let|const)\s+isAdult\s*=/.test(src);
  const usesGte = />=/.test(src);
  const declaresCenturies = /\b(let|const)\s+ageInCenturies\s*=/.test(src);
  const usesDiv = /\//.test(src);
  const logsAge = /console\s*\.\s*log\s*\(\s*age\s*\)/.test(src);
  const logsAdult = /console\s*\.\s*log\s*\(\s*isAdult\s*\)/.test(src);
  const logsCenturies = /console\s*\.\s*log\s*\(\s*ageInCenturies\s*\)/.test(src);

  if (!src.trim())
    display(hint(html`Fang an, die vier Schritte umzusetzen.`));
  else if (uebungRun.error)
    display(err(html`Fehler: ${uebungRun.error}`));
  else if (!declaresAge)
    display(err(html`Schritt 1 fehlt: <code>age</code> als Zahl deklarieren.`));
  else if (!declaresAdult)
    display(err(html`Schritt 2 fehlt: <code>isAdult</code> deklarieren.`));
  else if (!usesGte)
    display(err(html`Schritt 2: Verwende den Operator <code>>=</code> für den Vergleich.`));
  else if (!declaresCenturies)
    display(err(html`Schritt 3 fehlt: <code>ageInCenturies</code> deklarieren.`));
  else if (!usesDiv)
    display(err(html`Schritt 3: Verwende den Operator <code>/</code> für die Division.`));
  else if (!logsAge || !logsAdult || !logsCenturies)
    display(err(html`Schritt 4: Gib alle drei Variablen mit <code>console.log</code> aus.`));
  else
    display(ok(html`🎉 Übung gelöst! Du beherrschst die Grundrechenarten in JavaScript.`));
}
},
    inputs: ["uebung_code","display","hint","html","uebungRun","err","ok"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
